import { v4 as uuidv4 } from 'uuid';
import { MatchData } from '../../models/Calendar';

const deserializeTor24Match = ({ id, ...rest }: MatchData): MatchData => ({
  ...(id ? { id } : { externalId: uuidv4() }),
  ...rest,
});

export default deserializeTor24Match;
